import { useTranslation } from 'react-i18next';

import { Badge } from '@optiro/ui';

import { Task } from '@/types/types';

const statusColor: Record<string, string> = {
  scheduled: 'gray',
  in_progress: 'blue',
  completed: 'teal',
  overdue: 'red',
};

const TaskStatus = ({ task, size = 'md' }: { size?: 'sm' | 'md' | 'lg' | 'xs'; task: Task }) => {
  const { t: taskTranslation } = useTranslation('task');

  return (
    <Badge size={size} color={statusColor[task.status] ?? 'gray'} variant="light">
      {taskTranslation('status.' + task.status)}
    </Badge>
  );
};

export { TaskStatus };
